import React from "react";
import { Clock } from "lucide-react";
import { traditionColor } from "@/lib/traditionColors";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

// Top control bar: knowledge-system filter dropdown + undated tray toggle.
export const TimelineControls = ({
  systems,
  filterKs,
  setFilterKs,
  undatedCount,
  showUndated,
  setShowUndated,
}) => (
  <div className="flex items-center gap-3 flex-wrap px-5 py-2.5 border-b border-[#14140f]/8 bg-[#fdfdfb]">
    <span className="text-xs font-semibold uppercase tracking-wide text-[#14140f]/60">Filter</span>
    <Select value={filterKs} onValueChange={setFilterKs}>
      <SelectTrigger className="h-8 w-[240px] text-sm bg-white border-[#14140f]/15" data-testid="timeline-ks-filter">
        <SelectValue placeholder="All knowledge systems" />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value="all" data-testid="timeline-ks-filter-all">
          All knowledge systems
        </SelectItem>
        {systems.map((k) => (
          <SelectItem key={k.id} value={k.id} data-testid={`timeline-ks-filter-${k.id}`}>
            <span className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full" style={{ background: traditionColor(k.id) }} />
              {k.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    {filterKs !== "all" && (
      <button
        data-testid="timeline-ks-filter-clear"
        onClick={() => setFilterKs("all")}
        className="text-xs text-[#0a7d5f] hover:underline"
      >
        Clear
      </button>
    )}
    {undatedCount > 0 && (
      <button
        data-testid="timeline-undated-toggle"
        onClick={() => setShowUndated((v) => !v)}
        className="ml-auto flex items-center gap-1.5 text-xs text-[#4e6073] hover:text-[#14140f] border border-[#14140f]/10 rounded-full px-3 py-1 transition-colors"
      >
        <Clock className="w-3.5 h-3.5" />
        {showUndated ? "Hide" : "Show"} undated / legendary ({undatedCount})
      </button>
    )}
  </div>
);
